import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    updateRequest,
    updateOptions,
} from '@/actions/wizard/RequestWizardActions';
import Input from '@/elements/Input';

export default function BudgetOptions({ budgetTypes, selectedOption }) {
    const dispatch = useDispatch();
    const { meta, request } = useSelector((state) => state.requestWizard);

    // Update suggested budget
    useEffect(() => {
        if (!selectedOption || !selectedOption.priceRange) {
            dispatch(updateOptions('suggestedBudget', false));
            return;
        }

        // Multiply by number of days
        const days = Math.max(1, (request.mealDate?.length || 1));

        let min = selectedOption.priceRange[0] * request.guests * days,
            max = (selectedOption.priceRange[1] ?? 3000) * request.guests * days;

        // Apply (per-day) lower bound scaled by days when applicable
        const perDayLowerBound = selectedOption.lowerBound || selectedOption.minSpend;
        const lowerBound = perDayLowerBound ? perDayLowerBound * days : 0;
        if (min < lowerBound) min = lowerBound;
        if (max <= min) max = false;

        dispatch(updateOptions('suggestedBudget', [min, max]));
    }, [meta.step, selectedOption, request.guests, request.mealDate, meta.features]);

    const budgetOptions = budgetTypes?.options;
    if (!budgetOptions) return;

    const minSpendCopy =
        request.type == 'Full-time chef' ||
        request.type == 'Multi-day chef hire'
            ? 'Min day rate'
            : 'Min spend';

    const mappedOptions = budgetOptions.map((option, idx) => {
        return {
            label: (
                <>
                    <strong>{option.label}</strong>
                    {(option.priceRange || option.minSpend) && (
                        <p className="m-0 fs-14 fw-normal">
                            {option.priceRange?.length === 2 &&
                                `${meta.currencySign}${option.priceRange?.[0]} - ${meta.currencySign}${option.priceRange?.[1]}pp`}
                            {option.priceRange?.length === 1 &&
                                `${meta.currencySign}${option.priceRange?.[0]}pp+`}
                            {option.priceRange && option.minSpend && ' | '}
                            {option.minSpend &&
                                `${minSpendCopy} ${meta.currencySign}${option.minSpend.toLocaleString()}`}
                        </p>
                    )}
                    {option.description && (
                        <p className="m-0 fs-14 fw-normal">
                            {option.description}
                        </p>
                    )}
                    {idx == 1 && (
                        <span className="mt-1 badge badge-violet-200">
                            Most popular
                        </span>
                    )}
                </>
            ),
            value: option.value,
        };
    });

    return (
        <Input
            cols={
                meta.isMobile
                    ? 1
                    : budgetOptions.length < 3
                    ? budgetOptions.length
                    : 3
            }
            inputType="checkbox"
            value={[request.budgetType]}
            handleChange={(v) => dispatch(updateRequest('budgetType', v))}
            className={`input__checkbox -radio [&_.form-styling:nth-child(2)_label]:border-2`}
            optionClass="[&>span]:w-full"
            options={mappedOptions}
        />
    );
}
